export default {
	wheel: [36, 22, 63, 37, 55, 30, 49, 13, 19, 41, 60, 61, 54, 38, 58, 10, 11, 26, 5, 9, 34, 14, 43, 1, 44, 28, 50, 32, 57, 48, 18, 46, 6, 47, 64, 40, 59, 29, 4, 7, 33, 31, 56, 62, 53, 39, 52, 15, 12, 45, 35, 16, 20, 8, 23, 2, 24, 27, 3, 42, 51, 21, 17, 25].reverse() ,
	hex_width:   Math.PI/64.0,
	line_width:  Math.PI/64.0/6.0,
	color_width: Math.PI/64.0/6.0/6.0,
	tone_width:  Math.PI/64.0/6.0/6.0/6.0,
	base_width:  Math.PI/64.0/6.0/6.0/6.0/5.0,
}